export interface Action<P> {
    type: string;
    payload: P;
}

interface ActionCreator<P> {
  type?: string;
  (payload: P): Action<P>;
}

interface ActionTypesRegistry {
    [type: string]: boolean;
}

const actionTypes: ActionTypesRegistry = {};

export function actionCreator<P>(type: string): ActionCreator<P> {
    if (actionTypes[type]) {
        throw new Error(`Duplicate action type: ${type}`);
    }

    actionTypes[type] = true;

    return Object.assign(
        (payload: P): Action<P> => ({type, payload}),
        {type}
    );
}

export function actionCreatorFactory(typePrefix: string) {
    return function <P>(type: string): ActionCreator<P> {
        return actionCreator<P>(typePrefix + type);
    };
}

export function isType<P>(
    action: Action<any>,
    actionCreator: ActionCreator<P>
): action is Action<P> {
  return action.type === actionCreator.type;
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/redux/typedActions.ts
 **/